import { Box, Typography } from "@mui/material";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import { HERO_BG, fmtDay, rise } from "./emsTheme";

/** "13 Oct 2026" or "14 Sep to 13 Oct 2026" for the filters' date range. */
export const periodLabel = (filters) => {
    if (!filters?.dateFrom || !filters?.dateTo) return "All dates";
    const a = fmtDay(filters.dateFrom, true), b = fmtDay(filters.dateTo, true);
    return a === b ? a : `${fmtDay(filters.dateFrom)} to ${b}`;
};

/**
 * The gradient band at the top of each Analytics view: a pill with the period, the one-sentence
 * story, a footer line (focus chips, hints, the updated stamp) and the view's headline tiles,
 * which float over the band's lower edge.
 */
const AnalyticsHero = ({ pill, story, footer, tiles, storyRole = "status" }) => (
    <Box sx={{ position: "relative", ...rise(0) }}>
        <Box sx={{ position: "relative", overflow: "hidden", borderRadius: "16px", background: HERO_BG, color: "#fff",
            px: { xs: 2.5, md: 4 }, pt: { xs: 2.5, md: 3.5 }, pb: tiles ? { xs: 11, md: 12 } : { xs: 2.5, md: 3.5 } }}>
            <Box aria-hidden sx={{ position: "absolute", right: -60, top: -80, width: 260, height: 260, borderRadius: "50%", border: "1px solid rgba(255,255,255,.14)", pointerEvents: "none" }} />
            <Box aria-hidden sx={{ position: "absolute", right: 60, top: 40, width: 120, height: 120, borderRadius: "50%", bgcolor: "rgba(255,255,255,.06)", pointerEvents: "none" }} />
            <Box sx={{ position: "relative", display: "grid", gap: 1.25, maxWidth: 1000 }}>
                {pill && (
                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, alignSelf: "start", justifySelf: "start", px: 1.25, py: 0.5, borderRadius: "999px",
                        bgcolor: "rgba(255,255,255,.14)", border: "1px solid rgba(255,255,255,.22)" }}>
                        <InsightsOutlinedIcon sx={{ fontSize: 16 }} aria-hidden />
                        <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: ".04em" }}>{pill}</Typography>
                    </Box>
                )}
                <Typography role={storyRole} aria-live="polite" sx={{ fontSize: { xs: 20, md: 28 }, fontWeight: 800, lineHeight: 1.3, letterSpacing: "-.01em", textWrap: "balance" }}>
                    {story}
                </Typography>
                {footer && <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", minHeight: 34 }}>{footer}</Box>}
            </Box>
        </Box>
        {tiles && (
            <Box sx={{ position: "relative", zIndex: 1, mt: { xs: -9, md: -9.5 }, px: { xs: 1.5, md: 3 },
                display: "grid", gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" }, gap: 2 }}>
                {tiles}
            </Box>
        )}
    </Box>
);

export default AnalyticsHero;
